import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { GEMEENTEN } from "@/data/subsidie";

const API = process.env.REACT_APP_BACKEND_URL;
const inputCls = "w-full bg-white border border-[#E4E4E1] rounded-sm px-4 py-3 text-[#2F3438] placeholder:text-[#222]/30 focus:outline-none focus:border-[#2F3438] transition-colors";
const labelCls = "text-xs uppercase tracking-widest text-[#222]/50 block mb-2";

const init = { name: "", email: "", phone: "", postcode: "", house_number: "", gemeente: "", m2_glas: "", glas_type: "HR++ glas", woning_type: "", message: "" };

export const SubsidieCheckForm = () => {
  const [form, setForm] = useState(init);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/api/subsidiecheck`, form);
      toast.success("Uw subsidiecheck is verstuurd! U ontvangt een bevestiging per e-mail.");
      setForm(init);
    } catch {
      toast.error("Er ging iets mis. Probeer het opnieuw of bel ons op 06 40 62 74 99.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="subsidiecheck-form">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label className={labelCls}>Naam *</label>
          <input required value={form.name} onChange={set("name")} placeholder="Uw volledige naam" className={inputCls} data-testid="subsidie-name" />
        </div>
        <div>
          <label className={labelCls}>E-mail *</label>
          <input required type="email" value={form.email} onChange={set("email")} placeholder="naam@voorbeeld.nl" className={inputCls} data-testid="subsidie-email" />
        </div>
        <div>
          <label className={labelCls}>Telefoon *</label>
          <input required value={form.phone} onChange={set("phone")} placeholder="06 12345678" className={inputCls} data-testid="subsidie-phone" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className={labelCls}>Postcode *</label>
            <input required value={form.postcode} onChange={set("postcode")} placeholder="8900 AA" className={inputCls} data-testid="subsidie-postcode" />
          </div>
          <div>
            <label className={labelCls}>Huisnr. *</label>
            <input required value={form.house_number} onChange={set("house_number")} placeholder="12" className={inputCls} data-testid="subsidie-huisnummer" />
          </div>
        </div>
        <div>
          <label className={labelCls}>Gemeente *</label>
          <select required value={form.gemeente} onChange={set("gemeente")} className={inputCls} data-testid="subsidie-gemeente">
            <option value="" disabled>Kies uw gemeente</option>
            {GEMEENTEN.map((g) => <option key={g.naam} value={g.naam}>{g.naam}</option>)}
            <option value="Anders">Anders / buiten Fryslân</option>
          </select>
        </div>
        <div>
          <label className={labelCls}>Aantal m² glas (schatting)</label>
          <input value={form.m2_glas} onChange={set("m2_glas")} placeholder="bijv. 12" className={inputCls} data-testid="subsidie-m2" />
        </div>
        <div>
          <label className={labelCls}>Type glas</label>
          <select value={form.glas_type} onChange={set("glas_type")} className={inputCls} data-testid="subsidie-glastype">
            <option>HR++ glas</option>
            <option>Triple glas</option>
            <option>Weet ik nog niet</option>
          </select>
        </div>
        <div>
          <label className={labelCls}>Type woning</label>
          <select value={form.woning_type} onChange={set("woning_type")} className={inputCls} data-testid="subsidie-woningtype">
            <option value="">Kies (optioneel)</option>
            <option>Vrijstaand</option>
            <option>2-onder-1-kap</option>
            <option>Rijwoning / tussenwoning</option>
            <option>Hoekwoning</option>
            <option>Appartement</option>
            <option>Anders</option>
          </select>
        </div>
      </div>
      <div>
        <label className={labelCls}>Opmerking</label>
        <textarea rows={3} value={form.message} onChange={set("message")} placeholder="Vertel eventueel iets over uw situatie (optioneel)" className={inputCls} data-testid="subsidie-message" />
      </div>
      <button type="submit" disabled={loading} data-testid="subsidiecheck-submit" className="group inline-flex items-center gap-3 bg-[#2F3438] text-white px-7 py-4 rounded-sm hover:bg-[#222] transition-colors duration-300 disabled:opacity-60">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
        <span className="text-sm font-medium">Doe de vrijblijvende subsidiecheck</span>
        {!loading && <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform duration-300" />}
      </button>
    </form>
  );
};
